import { ModuleRegisterContext, ModuleRegisterFn } from "@/module-register"

const registerInstructionsModule: ModuleRegisterFn = (_context: ModuleRegisterContext) => {
  console.log("instructions module registered!")
}

export default registerInstructionsModule
